import * as React from "react";
const SvgSouthEast = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10V9z",
  fill: "currentColor"
}));
export default SvgSouthEast;